import { gsap } from "gsap";

/*
  CONFIG
  ------
  20 images split into 4 rows of 5.
  Replace the URLs in IMAGES with your own 20 image paths, in order.
  Row 1 gets images[0..4], row 2 gets images[5..9], etc.
*/
// const IMAGES = Array.from({length: 20}, (_, i) => ({
//     src: `https://picsum.photos/seed/row-${i}/400/300`,
//     href: `https://example.com/item-${i}` // replace with each image's real link
// }));

window.addEventListener('load', () => {

    const IMAGES = [
        {src: `${templateUrl}/resources/img/partners/logo1.png`, href: 'https://kig.pl/'},
        {src: `${templateUrl}/resources/img/partners/logo2.png`, href: 'https://www.ur.edu.pl/'},
        {src: `${templateUrl}/resources/img/partners/logo3.png`, href: 'https://prz.edu.pl/'},
        {src: `${templateUrl}/resources/img/partners/logo4.png`, href: 'https://rarr.rzeszow.pl/'},
        {src: `${templateUrl}/resources/img/partners/logo5.png`, href: 'https://www.international-hr.de/'},
        {src: `${templateUrl}/resources/img/partners/logo7.png`, href: 'https://www.exeolab.it/'},
        {src: `${templateUrl}/resources/img/partners/logo9.png`, href: 'https://www.archiviodellamemoria.it/'},
        {src: `${templateUrl}/resources/img/partners/logo11.png`, href: 'https://www.materahub.com/'},
        {src: `${templateUrl}/resources/img/partners/logo15.png`, href: 'https://www.kainotomia.com.gr/en/'},
        {src: `${templateUrl}/resources/img/partners/logo16.png`, href: 'https://www.uth.gr/'},
        {src: `${templateUrl}/resources/img/partners/logo17.png`, href: 'https://kek-dias.gr/'},
        {src: `${templateUrl}/resources/img/partners/logo18.png`, href: 'https://www.ebeh.gr/'},
        {src: `${templateUrl}/resources/img/partners/logo22.png`, href: 'https://innoeusphere.com/'},
        {src: `${templateUrl}/resources/img/partners/logo23.png`, href: 'https://dekaplus.eu/'},
        {src: `${templateUrl}/resources/img/partners/logo26.png`, href: 'https://aradcda.ro/en/'},
        {src: `${templateUrl}/resources/img/partners/logo28.png`, href: 'https://ed-knowledgeconsulting.com/'},
        {src: `${templateUrl}/resources/img/partners/logo32.png`, href: 'https://mindseurope.com/'},
        {src: `${templateUrl}/resources/img/partners/logo33.png`, href: 'https://www.mtu.ie/'},
        {src: `${templateUrl}/resources/img/partners/logo35.png`, href: 'https://www.mnunio.hu/'},
        {src: `${templateUrl}/resources/img/partners/logo37.png`, href: 'https://klasterit.pl'},
    ];

    const ROWS = 4;
    const IMAGES_PER_ROW = IMAGES.length / ROWS; // 5

    const wall = document.getElementById('wall');

    if (wall) {
        // Build DOM: for a seamless loop we duplicate each row's image set once,
        // then animate the track from 0 to -50% (exactly one full set width).
        const rowsData = [];

        for (let r = 0; r < ROWS; r++) {
            const rowImgs = IMAGES.slice(r * IMAGES_PER_ROW, (r + 1) * IMAGES_PER_ROW);

            const rowEl = document.createElement('div');
            rowEl.className = 'row';

            const trackEl = document.createElement('div');
            trackEl.className = 'track';

            // duplicate the set so the loop can wrap seamlessly
            const doubled = [...rowImgs, ...rowImgs];
            doubled.forEach(({src, href}) => {
                const link = document.createElement('a');
                link.href = href;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';

                const img = document.createElement('img');
                img.src = src;
                img.draggable = false;

                link.appendChild(img);
                trackEl.appendChild(link);
            });

            rowEl.appendChild(trackEl);
            wall.appendChild(rowEl);

            rowsData.push({track: trackEl, direction: r % 2 === 0 ? 'left' : 'right'});
        }

// Wait for images to load so widths are correct before measuring
        function whenImagesReady(container, cb) {
            const imgs = container.querySelectorAll('img');
            let loaded = 0;
            const total = imgs.length;
            imgs.forEach(img => {
                if (img.complete) {
                    loaded++;
                } else {
                    img.addEventListener('load', () => {
                        loaded++;
                        if (loaded === total) cb();
                    });
                    img.addEventListener('error', () => {
                        loaded++;
                        if (loaded === total) cb();
                    });
                }
            });
            if (loaded === total) cb();
        }

        whenImagesReady(wall, () => {
            rowsData.forEach(({track, direction}) => {
                // half the width = width of one (non-duplicated) set
                const fullWidth = track.scrollWidth / 2;

                // Base speed: pixels per second (tweak to taste)
                const pxPerSecond = 30;
                const duration = fullWidth / pxPerSecond;

                const tween = direction === 'left'
                    ? gsap.fromTo(track,
                        {x: 0},
                        {x: -fullWidth, duration: duration, ease: 'none', repeat: -1}
                    )
                    : gsap.fromTo(track,
                        {x: -fullWidth},
                        {x: 0, duration: duration, ease: 'none', repeat: -1}
                    );

                // pause the whole row's scroll while the cursor is over it,
                // so people can actually click a link without it sliding away
                const rowEl = track.parentElement;
                rowEl.addEventListener('mouseenter', () => tween.pause());
                rowEl.addEventListener('mouseleave', () => tween.resume());
            });
        });
    }

    const sphereEl = document.getElementById('sphere');

    if (sphereEl) {

// ---- Config ----
        const COUNT = 15;
        const ASPECT_X = 1.6;  // 16:10 -> stretch horizontally
        const ASPECT_Y = 1.0;  // baseline vertical
        const ASPECT_Z = 1.3;  // keep some depth so rotation still reads as 3D
        const RADIUS = 130;    // base radius before aspect scaling
        const AUTO_SPEED = 0.12; // deg per ms-ish (scaled by ticker delta)

        const FRAMEWORKS = [
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-original-wordmark.svg',
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laminas/laminas-original-wordmark.svg',
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/symfony/symfony-original-wordmark.svg',
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg',
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg',
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original-wordmark.svg',
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wordpress/wordpress-original.svg',
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/reactnative/reactnative-original-wordmark.svg',
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original-wordmark.svg',
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original-wordmark.svg',
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original-wordmark.svg',
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg',
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mariadb/mariadb-original-wordmark.svg',
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/moodle/moodle-original-wordmark.svg',
            'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/threejs/threejs-original-wordmark.svg',
        ];


// Fibonacci sphere distribution -> even spacing of points on a sphere,
// then stretched per-axis into an ellipsoid to match a 16:10 shape.
        function fibonacciEllipsoid(n, radius, ax, ay, az) {
            const points = [];
            const offset = 2 / n;
            const increment = Math.PI * (3 - Math.sqrt(5)); // golden angle
            for (let i = 0; i < n; i++) {
                const y = i * offset - 1 + offset / 2;
                const r = Math.sqrt(1 - y * y);
                const phi = i * increment;
                const x = Math.cos(phi) * r;
                const z = Math.sin(phi) * r;
                points.push({
                    x: x * radius * ax,
                    y: y * radius * ay,
                    z: z * radius * az
                });
            }
            return points;
        }

        const basePoints = fibonacciEllipsoid(COUNT, RADIUS, ASPECT_X, ASPECT_Y, ASPECT_Z);

        const items = FRAMEWORKS.map((src, i) => {
            const el = document.createElement('div');
            el.className = 'item';
            const img = document.createElement('img');
            img.src = src;
            img.alt = '';
            img.draggable = false;
            el.appendChild(img);
            sphereEl.appendChild(el);
            return {el, base: basePoints[i]};
        });

// Current rotation state (degrees), driven by auto-rotate + drag
        const state = {rotX: -12, rotY: 0};
        let velX = 0, velY = 0;
        let dragging = false;
        let lastX = 0, lastY = 0;

        function rotatePoint(p, radX, radY) {
            // rotate around Y axis first
            let x = p.x * Math.cos(radY) + p.z * Math.sin(radY);
            let z = -p.x * Math.sin(radY) + p.z * Math.cos(radY);
            let y = p.y;

            // then rotate around X axis
            let y2 = y * Math.cos(radX) - z * Math.sin(radX);
            let z2 = y * Math.sin(radX) + z * Math.cos(radX);

            return {x, y: y2, z: z2};
        }

        function render() {
            const radX = state.rotX * Math.PI / 180;
            const radY = state.rotY * Math.PI / 180;

            items.forEach(({el, base}) => {
                const p = rotatePoint(base, radX, radY);
                const zRadius = RADIUS * ASPECT_Z;
                const scale = (p.z + zRadius * 1.6) / (zRadius * 2.6); // depth-based scale
                const opacity = 0.35 + 0.65 * ((p.z + zRadius) / (zRadius * 2));

                gsap.set(el, {
                    x: p.x,
                    y: p.y,
                    z: p.z,
                    scale: scale,
                    opacity: opacity,
                    zIndex: Math.round(p.z + 1000)
                });
            });
        }

        gsap.ticker.add(() => {
            if (!dragging) {
                state.rotY += AUTO_SPEED + velY;
                state.rotX += velX;
                // damping for residual drag momentum
                velX *= 0.95;
                velY *= 0.95;
            }
            render();
        });
    }
});